/* eslint-disable */
'use strict';

(function() {
    function checkCookieBotConsentDataLayer(eventObj) {
        if (!Array.isArray(window.dataLayer)) {
            window.dataLayer = [];
        }

        // Local queue for events
        window._cbQueue = window._cbQueue || [];

        // Consent check function.
        // SC-16905: outside production nothing pushes cookie_consent_update (Cookiebot is not
        // configured there), so every event stayed queued below and never reached the dataLayer -
        // which made GTM/GA4 impossible to test on dev. window.gtmDefaultConsent is set by
        // gtm/gtmScript.isml from the enableDefaultCookieConsent site preference, and is never set
        // on production, so real shopper consent is still required there.
        const hasConsent = () =>
            window.gtmDefaultConsent === true ||
            window.dataLayer.some(e => e?.event === "cookie_consent_update");

        // SC-8197: if consent is already resolved, push synchronously. Click-driven events
        // (e.g. navigation_click) fire on links that navigate the browser away immediately -
        // deferring behind the setTimeout below lost the race against navigation tearing down
        // this page's JS context, so the push never happened on real nav-link clicks.
        if (hasConsent()) {
            window.dataLayer.push(eventObj);
            return;
        }

        setTimeout(() => { // Adding timeout to avoid the race condition SC-4572
            // If consent is present, push immediately
            if (hasConsent()) {
                window.dataLayer.push(eventObj);
                return;
            }

            // Else queue it and set up listener once
            window._cbQueue.push(eventObj);

            if (!window._cbWatcher) {
                const originalPush = window.dataLayer.push;

                window.dataLayer.push = function (...args) {
                    const result = originalPush.apply(this, args);

                    if (hasConsent() && window._cbQueue.length && !window._cbFlushing) {
                        window._cbFlushing = true;
                        const pending = window._cbQueue.slice();
                        window._cbQueue.length = 0;
                        pending.forEach(obj => {
                            originalPush.call(window.dataLayer, obj);
                        });
                        window._cbFlushing = false;
                    }

                    return result;
                };

                window._cbWatcher = true;
            }
        }, 2000);
    }

    if (typeof window !== 'undefined') {
        if (!window.consentChecker) {
            window.consentChecker = {};
        }
        window.consentChecker.checkCookieBotConsentDataLayer = checkCookieBotConsentDataLayer;
    }

    if (typeof module !== 'undefined' && module.exports) {
        module.exports = {
            checkCookieBotConsentDataLayer: checkCookieBotConsentDataLayer
        };
    }
})();